import React from 'react';
import { Field, ErrorMessage } from 'formik';
import Select, { components } from 'react-select';
import _ from 'lodash';
import { TextError } from 'components/FormikComponents';
import { FasInfoCircle, FasExclamation } from 'assets/icons';

const SelectStyles = {
    control: (styles, { selectProps }) => {
        return ({
            ...styles,
            border: !selectProps.value ? '1px solid #AB0731' : 'auto',
            ':hover': {
                border: !selectProps.value ? '1px solid #AB0731' : 'auto'
            },
            ':focus': {
                border: !selectProps.value ? '1px solid #AB0731' : 'auto'
            }
        });
    },
    dropdownIndicator: (styles, { selectProps }) => {
        return ({
            ...styles,
            display: 'flex',
            justifySelf: 'flex-end'
        });
    }
};

const CustomControl = ({ children, ...props }) => {
    const { selectProps } = props;

    return (
        <components.Control {...props}>
            {
                selectProps.value ? (
                    <>
                        <div className="protocol-select-field">{children}</div>
                        <div className="secondary-text-control">{selectProps.value?.secondary}</div>
                    </>
                ) : (
                    <>
                        <button
                            type="button"
                            title="This field is required"
                            className="fn-btn delete"
                        >
                            <FasExclamation />
                        </button> {children}
                    </>
                )
            }

        </components.Control>
    );
};

const CustomOption = (props) => {
    const { children, data } = props;
    return (
        <>
            <components.Option {...props}>
                <div className={`row ${data.isDisabled ? 'disable-prot-status-opt' : ''}`}>
                    <div className="col-11">
                        <div className="primary-text">{children}</div>
                        <div className="secondary-text">{data.secondary}</div>
                    </div>
                    <div className="col-1">
                        {(children === 'Active' || children === 'Pre-Activation') && (
                            !_.isEmpty(data.preActiveMsg) && _.includes(data.allowedStatus, children) && (
                                <button
                                    type="button"
                                    title={data.preActiveMsg}
                                    className="fn-btn delete"
                                >
                                    <FasInfoCircle />
                                </button>
                            )
                        )}
                    </div>
                </div>
            </components.Option>
        </>
    )

};

const Status = ({ field, form, ...props }) => {
    return (
        <Select onChange={field.onChange} styles={SelectStyles} components={{ Option: CustomOption, Control: CustomControl }} {...field} {...props} />
    );
}

const ProtocolStatus = (props) => {
    const { label, name, title, isDisabled, required, ...rest } = props;
    return (
        <li>
            <label htmlFor="name">
                {required ? <span className="form-layout-required">*</span> : ''}
                {label}
            </label>
            {
                !isDisabled ? (
                    <div className="form-layout-input" title={title}>
                        <Field
                            name={name}
                            id={name}
                            component={Status}
                            className="select-dropdown-indicator pl-1"
                            {...rest}
                        />
                        <ErrorMessage name={name} component={TextError} />
                    </div>
                ) : (
                    <div className="form-layout-input" title={title}>
                        {rest.value?.value || ''}
                    </div>
                )
            }
        </li>
    );
};

export default ProtocolStatus;